import React from "react";
import { UserCircle2, Mail, Instagram, Globe, ChevronRight } from "lucide-react";
import PageShell from "@/components/PageShell";

const CONTACTS = [
  { Icon: UserCircle2, label: "Arundhati", value: "+91 73893 90602", href: "tel:+917389390602" },
  { Icon: UserCircle2, label: "Muskaan", value: "+91 75298 60857", href: "tel:+917529860857" },
  { Icon: Mail, label: "Email", value: "info@sproutsedutours.in", href: "mailto:info@sproutsedutours.in" },
  { Icon: Instagram, label: "Instagram", value: "@sproutsedutour", href: "https://instagram.com/sproutsedutour" },
  { Icon: Globe, label: "Website", value: "www.sproutsedutours.in", href: "https://www.sproutsedutours.in" },
];

export default function Contact() {
  return (
    <PageShell testid="contact-screen">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <h1 className="text-3xl sm:text-4xl font-black text-sprouts-text">Get in Touch</h1>
        <p className="text-base text-sprouts-muted mt-2">
          Questions about registration, submissions or prizes? Reach out to our team.
        </p>

        <div className="mt-8 grid gap-3">
          {CONTACTS.map(({ Icon, label, value, href }) => (
            <a
              key={label}
              href={href}
              target={href.startsWith("http") ? "_blank" : undefined}
              rel="noopener noreferrer"
              data-testid={`contact-${label.toLowerCase()}`}
              className="flex items-center gap-4 bg-white px-4 py-4 rounded-2xl border border-sprouts-border shadow-soft hover:shadow-card transition-shadow"
            >
              <div className="w-11 h-11 rounded-full bg-sprouts-lavender flex items-center justify-center shrink-0">
                <Icon size={22} className="text-sprouts-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-bold text-sprouts-muted">{label}</p>
                <p className="text-sm sm:text-base font-extrabold text-sprouts-text truncate">{value}</p>
              </div>
              <ChevronRight size={18} className="text-sprouts-muted" />
            </a>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
